export default __webpack_public_path__ + "static/media/zombie_cat.94619d02.png";